export const formatDateTime = (val?: string | null): string => {
  if (!val) return '—'
  const date = new Date(val)
  if (isNaN(date.getTime())) return '—'

  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

export const formatDate = (val?: string | null): string => {
  if (!val) return '—'
  const date = new Date(val)
  if (isNaN(date.getTime())) return '—'

  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}
